<template>
  <div>
    <v-dialog v-model="show" persistent width="450">
      <v-card color="primary" dark>
        <v-card-text>
          <span v-html="message"></span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "LoadingDialog",
  props: {
    show: Boolean,
    message: String
  }
};
</script>
